"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlagResponseToJSON = exports.FeatureFlagResponseFromJSONTyped = exports.FeatureFlagResponseFromJSON = void 0;
const runtime_1 = require("../runtime");
function FeatureFlagResponseFromJSON(json) {
    return FeatureFlagResponseFromJSONTyped(json, false);
}
exports.FeatureFlagResponseFromJSON = FeatureFlagResponseFromJSON;
function FeatureFlagResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'enabled': json['enabled'],
        'startTime': !runtime_1.exists(json, 'start_time') ? undefined : (new Date(json['start_time'])),
        'endTime': !runtime_1.exists(json, 'end_time') ? undefined : (new Date(json['end_time'])),
    };
}
exports.FeatureFlagResponseFromJSONTyped = FeatureFlagResponseFromJSONTyped;
function FeatureFlagResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'enabled': value.enabled,
        'start_time': value.startTime === undefined ? undefined : (value.startTime.toISOString()),
        'end_time': value.endTime === undefined ? undefined : (value.endTime.toISOString()),
    };
}
exports.FeatureFlagResponseToJSON = FeatureFlagResponseToJSON;
//# sourceMappingURL=FeatureFlagResponse.js.map